import AppConfigs from 'general/constants/AppConfigs';
import axiosClient from './axiosClient';

const maintainerApi = {
    // dang ky
    signUp: (params) => {
        const url = '/maintainer/register';
        return axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },

    // dang nhap
    signIn: (params) => {
        const url = '/maintainer/login';
        return axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },

    // dang xuat
    signOut: (params) => {
        const url = '/maintainer/logout';
        return axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },

    // lay thong tin tai khoan
    getProfile: () => {
        const url = '/maintainer/profile';
        return axiosClient.get(url, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },

    // change password
    changePassword: (params) => {
        const url = `/maintainer/changePassword`;
        return axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },

    // quen mat khau
    forgotPassword: (email) => {
        const url = `/maintainer/forgot`;
        const params = {
            email: email,
        };
        return axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },

    // dat lai mat khau (user chua dang nhap)
    resetPasswordUser: (params) => {
        const url = `/maintainer/reset`;
        return axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },

    // lay danh sach KTV
    getMaintainerList: (params = {}) => {
        const url = '/maintainer';
        return axiosClient.get(url, {
            params,
            baseURL: `${AppConfigs.env.baseUrl}api/v1`
        });
    },
};

export default maintainerApi;
